<template>
    <b-row>
        <b-col cols="12">
          <loading :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="fullPage"
            :opacity="1"
            color="#d3a971"
            >
          </loading>
          <HomeHeader></HomeHeader>
          <b-col class="d-flex justify-content-center"  v-for="(menu, index) in menus" v-bind:key="index">
            <router-link :to="`/${menu.url}`">
            <b-card no-body class="overflow-hidden shadow-sm menuCard" style="max-width: 540px;">
              <b-row no-gutters>
                <b-col md="6">
                  <b-card-img  v-bind:src=" menu.menuImage " alt="Image" class="rounded-0"></b-card-img>
                </b-col>
                <b-col md="6">
                  <b-card-body>
                    <b-card-title>{{ menu.location }}</b-card-title>
                    <b-card-text class="mb-2">{{ menu.address1 + ' ' + menu.address2 + ' ' + menu.city }}</b-card-text>
                    <hr class="h-rule" />
                    <b-card-text>
                      {{ menu.menuDescription }}
                    </b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
            </router-link>
          </b-col>
          <HomeFooter></HomeFooter>
        </b-col>
    </b-row>
</template>

<script>
import HomeHeader from './componentParts/HomeHeader';
import HomeFooter from './componentParts/HomeFooter';

import Loading from 'vue-loading-overlay';
import firebase from '../Firebase'
import router from '../router'

export default {
  name: 'AllMenus',
  components: {
    HomeHeader,
    HomeFooter,
    Loading
  },
  data () {
    return {
      fields: {
        title: { label: 'Title', sortable: true, 'class': 'text-left' },
        actions: { label: 'Action', 'class': 'text-center' }
      },
      menus: [],
      errors: [],
      ref: firebase.firestore().collection('spain'),
      isLoading: false,
      fullPage: true
    }
  },
  created () {
    this.isLoading = true
    this.ref.onSnapshot((querySnapshot) => {
      this.menus = [];
      querySnapshot.forEach((doc) => {
        this.menus.push({
          location: doc.data().locationName,
          url: doc.data().url,
          menuId: doc.data().locationId,
          address1: doc.data().address1,
          address2: doc.data().address2,
          city: doc.data().city,
          menuDescription: doc.data().menuDescription,
          menuImage: doc.data().menuImage,
          menuName: doc.data().menuName,        
        });
      });
        setTimeout(() => {
          this.isLoading = false
        },500)
    });
  },
  methods: {
    details (menu) {
      router.push({ name: 'Showmenu', params: { id: menu.key }})
    }
  }
}
</script>

<style>
  .menuCard{
    margin-top: 10px;
    margin-bottom: 10px;
    border: 0px !important;
    
  }
  .menuListContainer {
    text-align: center;
  }
  .h-rule {
    width: 50px;
  }

</style>